// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-portal-wrapper {
  position: fixed;
  width: 100%;
  height: calc(100vh - 6rem);
  top: 6rem;
  left: 0;
  z-index: 1000;
  overflow-y: auto;
  overflow-x: hidden;
}
.modal-portal-wrapper .overlay {
  position: fixed;
  top: 6rem;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 719px) {
  .modal-portal-wrapper {
    height: calc(100vh - 8rem);
    top: 8rem;
  }
  .modal-portal-wrapper .overlay {
    top: 8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Popups/ModalPortal/index.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,0BAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AACF;AACE;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;AACJ;AAEE;EAnBF;IAqBI,0BAAA;IACA,SAAA;EAAF;EAEE;IACE,SAAA;EAAJ;AACF","sourcesContent":[".modal-portal-wrapper {\n  position: fixed;\n  width: 100%;\n  height: calc(100vh - 6rem);\n  top: 6rem;\n  left: 0;\n  z-index: 1000;\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  .overlay {\n    position: fixed;\n    top: 6rem;\n    left: 0;\n    background-color: rgba(0, 0, 0, 0.5);\n    width: 100%;\n    height: 100%;\n  }\n\n  @media screen and (max-width: 719px) {\n    //padding: 3.2rem 1.6rem;\n    height: calc(100vh - 8rem);\n    top: 8rem;\n\n    .overlay {\n      top: 8rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
